module.exports = __webpack_public_path__ + "img/back-w.7672d425.png";